var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row d-lg-flex align-items-center mt-4"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"intro-section__powered-by"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("\n        Powered by "),_c('span',[_vm._v("getpica.com")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }